import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button/Button';
import useOnSubmit from './hooks/useOnSubmit';

import ChangeAssessmentStateModal from '../ChangeAssessmentStateModal/ChangeAssessmentStateModal';

const MarkAsFinal = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = useOnSubmit(setIsOpen);

  return (
    <>
      <Button className="mark-as-final" variant="black-filled" onClick={() => setIsOpen(true)}>
        {t('pages.projectOverview.mainPanel.markAsFinal.button')}
      </Button>
      <ChangeAssessmentStateModal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        onSubmit={onSubmit}
        title={t('pages.projectOverview.mainPanel.markAsFinal.modalTitle')}
        isEligibilityRequired
        submitButton={
          <Button className="mark-as-final" variant="black-filled" type="submit">
            {t('pages.projectOverview.mainPanel.markAsFinal.button')}
          </Button>
        }
      />
    </>
  );
};

export default MarkAsFinal;
